import React, { useRef, useState, useEffect, useCallback } from 'react'
import styles from '../../IssueType.module.css'
import TopTitleBar from '../../TopTitleBar';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import API from '../../../../../ApiConfig'
import { BASE_URL, COPY_PACKAGE_TO_USER, GET_FORM_DETAILS, GET_VERIFIER_FORM, USER_TOKEN } from '../../../../../Utils/constant'
import { Delay, _ToNormal, getUserId, setDate } from '../../../../../Utils/helper';
import cogoToast from 'cogo-toast-react-17-fix';
import useRefreshToken from '../../../../../Hooks/usegenerateToken';
import SlideUpWrapper from '../../../../../components/Transitions/SlideUpWrapper';
import ShimmerLoader from '../../../../../components/ShimmerLoader';
import Loader from '../../../../../components/Loader';
import BreadCrumb from '../../../../../components/Verifier/breadcrumb/BreadCrumb';

import Icon from 'react-icons-kit';
import { userAdd } from 'react-icons-kit/typicons/userAdd'
import { spreadsheet } from 'react-icons-kit/iconic/spreadsheet'
import { chevronRight } from 'react-icons-kit/oct/chevronRight'
import IssuerNavigator from '../../../../../components/DashBoard/IssuerNavigator';
import Each from '../../../../../components/Each';

const SelectForm = ({ id }) => {
    useRefreshToken(BASE_URL + USER_TOKEN)

    const navigate = useNavigate()
    const location = useLocation();
    const form = location.state?.form || false

    const user_id = getUserId()
    const [loading, setLoading] = useState(false)
    const [selectedOption, setSelectedOption] = useState();
    const [data, setData] = useState([])

    const [documentData, setDocumentData] = useState(null)
    const [doctype, setdoctype] = useState(true)

    useEffect(() => {
        setSelectedOption(form)
    }, [form])

    useEffect(() => {
        getFormDetails()
    }, [])

    async function getFormDetails() {
        setLoading(true)
        await Delay()
        API.get(`${GET_FORM_DETAILS}${form.form_uuid}/${form.form_type}?verifier_id=${user_id}`)
            .then(res => {
                setLoading(false)
                if (res.data.status === 200) {
                    // let temp = res.data.data
                    // let result = []
                    // Object.keys(temp).map(item => {
                    //     result = [...result, ...temp[item]]
                    // })
                    // setData(result)
                    setData(res.data.data)
                    if (res.data.data.required_doc_fields.length > 0) {
                        setDocumentData(res.data.data.required_doc_fields)
                        setdoctype(false)
                    }
                    else
                        setDocumentData(res.data.data.required_documents)


                }
            })
            .catch(err => {
                setLoading(false)
                cogoToast.error('Something went wrong while fetching details!')
            })
    }



    const handleSubmit = (form_type) => {
        let template_type = form.form_type
        const handleCopyDocument = () => {
            var date = new Date();
            let payload = {
                template_name: form.form_name + date.getSeconds().toString() + date.getMilliseconds().toString(),
                predefined_form_id: form.id,
                verifier_id: user_id
            }

            API.post(COPY_PACKAGE_TO_USER, payload)
                .then(res => {
                    setLoading(false)
                    if (res.data.status === 200) {
                        setSelectedOption(res.data.data)
                        form_type ? navigate('../forms/RecipientsDetails', { state: { selectedOption: res.data.data } }) : navigate('../forms/BulkRecipients', { state: { selectedOption: res.data.data } })
                    }
                })
                .catch(err => {
                    setLoading(false)
                    cogoToast.error('Something went wrong while fetching details!')
                })
        }

        if (template_type)
            form_type ? navigate('../forms/RecipientsDetails', { state: { selectedOption } }) : navigate('../forms/BulkRecipients', { state: { selectedOption } })
        else
            handleCopyDocument()
    }

    const boxStyle = {
        borderRadius: 'var(--br-5xs)',
        flexWrap: 'wrap',
        padding: '1rem',
        boxSizing: 'border-box',
        border: '1px solid var(--gray-200)',
        margin: '1.5rem 0rem',
        background: 'white'
    }

    const Card = ({ clickhandle, title, subtext, icon }) => {
        icon = icon ? spreadsheet : userAdd
        return (
            <div onClick={e => handleSubmit(clickhandle)} className='issuer-container container justify-content-flex-start navItemContainer' style={{ cursor: 'pointer', alignItems: 'center' }}>
                <div className={styles.icon} style={{ padding: '0.5rem', height: '2rem', width: '2rem', fontWeight: "700", fontSize: "15px", background: '#EFFAF6' }}>
                    <Icon icon={icon} style={{ color: '#2D9F75' }} size={'1.5rem'} />
                </div>
                <div>
                    <div className={styles.title}>
                        {title}
                    </div>
                    <span className={styles.para} style={{ margin: 0 }}>
                        {subtext}
                    </span>
                </div>
                <Icon icon={chevronRight} />
            </div>
        )
    }


    const FormData = useCallback(() => {
        // return (
        //     <div className="credentials-table">
        //         <div>{form.form_name}</div>
        //         <table>
        //             <tr className="credentials-header bg-lgray">
        //                 <th className="credentials-th">
        //                     <div className="credentials-table-text">Field</div>
        //                 </th>
        //                 <th className="credentials-th"><div className="credentials-table-text">Documents</div></th>
        //                 <th className="credentials-th">
        //                     <div className="credentials-table-text">Created At</div>
        //                     <img className="chevronSortIcon" alt="" src="/chevronsort.svg" />
        //                 </th>

        //             </tr>
        //             <tbody>
        //                 {loading ?
        //                     (
        //                         [...Array(2)].map((_, index) => (
        //                             <tr className="credentials-header">
        //                                 <td className="credentials-th flex-grow-2">
        //                                     <div className="credentials-table-text">
        //                                         <div className="shimmer" style={{ width: '7rem' }}></div>
        //                                     </div>
        //                                 </td>

        //                                 <td className="credentials-th flex-grow-2">
        //                                     <div className="credentials-table-text">
        //                                         <div className="shimmer" style={{ width: '7rem' }}></div>
        //                                     </div>
        //                                 </td>
        //                                 <td className="credentials-th">
        //                                     <div className="credentials-table-text">
        //                                         <div className="shimmer" style={{ width: '7rem' }}></div>
        //                                     </div>
        //                                 </td>
        //                             </tr>
        //                         ))
        //                     ) :
        //                     (
        //                         <Each of={data} render={(item, index) => (
        //                             <tr className="credentials-header" key={index}>
        //                                 <td className="credentials-th">
        //                                     <div className="credentials-table-text">{item.doc_field_name}</div>
        //                                 </td>
        //                                 <td className="credentials-th">
        //                                     <div className="credentials-table-text">{item.linked_documents.join(", ")}</div>
        //                                 </td>
        //                                 <td className="credentials-th">
        //                                     <div className="credentials-table-text">{moment(item.created_at).format('DD MMM YYYY')}</div>
        //                                 </td>
        //                             </tr>
        //                         )} />)
        //                 }
        //             </tbody>
        //         </table>
        //     </div>
        // )

        const ShowTags = () => {
            if (loading) {
                return (
                    [...Array(2)].map((_, index) => (
                        <tr className="custom-tr">
                            <td className="custom-td"><div className="shimmer"></div></td>
                            <td className="custom-td"><div className="shimmer"></div></td>
                            <td className="custom-td"><div className="shimmer"></div></td>
                        </tr>
                    ))
                )
            }
            else if (documentData) {
                if (doctype) {
                    return (
                        documentData.map((val, index) => (
                            <tr className="custom-tr" key={val.master_document_id} style={loading ? null : { animationDelay: `${index * 0.1}s` }}>
                                <td className="custom-td">{val.master_document_name}</td>
                                <td className="custom-td">{val.count}</td>
                            </tr>
                        ))
                    )
                }
                else {
                    return (
                        documentData.map((val, index) => (
                            <tr className="custom-tr" key={val.master_doc_field_id} style={loading ? null : { animationDelay: `${index * 0.1}s` }}>
                                <td className="custom-td">{val.doc_field_name}</td>
                                <td className="custom-td">{val.linked_documents.join(", ")}</td>
                            </tr>
                        ))
                    )
                }

            }

        }


        return (
            <div className="w-50">
                <h1 className="header-title">
                    {form.form_name}
                </h1>
                <div className="container justify-content-flex-start navItemContainer" style={{ margin: '1rem 0rem' }}>
                    <div className="issuer-label-wrapper">
                        <span>Created on</span>
                        <span className="issuer-label">{setDate(data.updated_at)}</span>
                    </div>
                    <div className="issuer-label-wrapper">
                        <span>Document Type</span>
                        <span className="issuer-label">{data.type ? 'Custom' : 'Master form'}</span>
                    </div>
                </div>
                <table className="custom-table">
                    <tr className='credentials-header'>
                        <td className="custom-th">Form Fields</td>
                        {/* <td className="custom-th">Tags</td> */}
                        <td className="custom-th">{doctype ? 'Counts' : 'Source Document'}</td>
                    </tr>
                    <ShowTags />
                </table>
            </div>
        )
    }, [data])

    return (

        <>
            <div style={{ width: "100%" }}>
                <BreadCrumb pos={2} title={"Request Verification"} category={'verification'} />
                <IssuerNavigator
                    title={'Add Receipient Details'}
                    step={'/dashboard/forms/selectForms'}
                    actions={() => null}
                />
                <SlideUpWrapper direction='slide-left'>
                    <div className='issuer-container'>
                        <Loader isOpen={loading} />
                        <FormData />
                        <div className='container justify-content-flex-start navItemContainer'>
                            <Card clickhandle={1} title={'Manually,one by one'} subtext={'ideal for quick start'} icon={0} />
                            <Card clickhandle={0} title={'Bulk Via CSV'} subtext={'Upload via spredsheet'} icon={1} />
                        </div>
                    </div>
                </SlideUpWrapper>
            </div>
        </>
    )
}

export default SelectForm
